import React, { useState } from "react";
import { useAuditLogs } from "../../api/auditLogs";
import { PaginationBar } from "../../components/PaginationBar";
import { formatDate } from "../../utils/money";

const ENTITY_TYPES = [
  "",
  "User",
  "Customer",
  "Receivable",
  "Payable",
  "BankSlip",
  "ServiceInvoice",
  "PortalSettings",
];

const ACTION_LABEL: Record<string, string> = {
  login: "Login",
  create: "Criação",
  update: "Atualização",
  status_change: "Mudança de status",
  baixa: "Baixa",
  cancel: "Cancelamento",
  emit: "Emissão",
  emit_batch: "Emissão em lote",
  mark_paid: "Marcado como pago",
  invite_portal_access: "Convite ao portal",
  reset_password: "Redefinição de senha",
};

export default function AuditLogsPage() {
  const [page, setPage] = useState(1);
  const [entityType, setEntityType] = useState("");
  const { data, isLoading, isError } = useAuditLogs({ page, pageSize: 7, entityType: entityType || undefined });

  return (
    <div className="d-flex flex-column gap-3">
      <div className="row g-2">
        <div className="col-md-3">
          <label className="nt-field-label">Entidade</label>
          <select
            className="form-select"
            value={entityType}
            onChange={(e) => {
              setEntityType(e.target.value);
              setPage(1);
            }}
          >
            <option value="">Todas as entidades</option>
            {ENTITY_TYPES.filter(Boolean).map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </div>
      </div>

      {isLoading && <div className="text-secondary">Carregando…</div>}
      {isError && <div className="text-danger">Não foi possível carregar o log de auditoria.</div>}

      {data && (
        <div className="nt-table-wrap" style={{ overflowX: "auto" }}>
          <table className="table nt-table-fade table-striped align-middle">
            <thead>
              <tr>
                <th style={{ width: 160 }}>Quando</th>
                <th>Ator</th>
                <th style={{ width: 160 }}>Ação</th>
                <th style={{ width: 160 }}>Entidade</th>
                <th style={{ width: 140 }}>IP</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((log) => (
                <tr key={log.id}>
                  <td className="nt-tabular text-secondary">{formatDate(log.createdAt)}</td>
                  <td>{log.actorUser ? log.actorUser.name : log.actorType === "CUSTOMER" ? "Cliente (portal)" : "Sistema"}</td>
                  <td>{ACTION_LABEL[log.action] ?? log.action}</td>
                  <td className="text-secondary">
                    {log.entityType} · {log.entityId}
                  </td>
                  <td className="nt-tabular text-secondary">{log.ip ?? "—"}</td>
                </tr>
              ))}
              {data.data.length === 0 && (
                <tr>
                  <td colSpan={5} className="text-secondary text-center py-4">
                    Nenhum registro de auditoria ainda.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {data && <PaginationBar page={data.page} pageSize={data.pageSize} total={data.total} onPageChange={setPage} />}
    </div>
  );
}
